import React, { useState } from 'react';

// Компонент TreeNode для отображения каждого узла дерева
const TreeNode = ({ item, children, selectedId, selectedParent, selectedItems, onToggle, onSelect, withCheckboxes }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggle = (e) => {
      e.stopPropagation();
      setIsOpen(!isOpen);
    };
  
    const handleCheck = (e) => {
      onToggle(item.id, e.target.checked);
    };

    const handleClick = () => {
      onSelect(item);
      console.log(item.id);
    };

    const displayName = item.name && item.name.trim() !== '' ? item.name : '<Без имени>';

    return (
      <div style={{ marginLeft: 20 }}>
      <div
        onClick={handleClick}
        style={{
          cursor: 'pointer',
          backgroundColor: selectedId === item.id ? 'lightblue' : 'transparent',
        }}
      >
        {/* Условие для отображения чекбоксов */}
        {withCheckboxes && item.isFolder !== 1 && (
          <input
            type="checkbox"
            checked={selectedItems?.has(item.id) || false}
            onChange={handleCheck}
            onClick={(e) => e.stopPropagation()}
          />
        )}
        {displayName}
        {children.length > 0 && (
          <span onClick={toggle} style={{ marginLeft: 5 }}>
            {isOpen ? '-' : '+'}
          </span>
        )}
      </div>
        {isOpen && (
          <div>
            {children.map(child => (
              <TreeNode key={child.id} item={child.item} children={child.children} selectedId={selectedId} selectedItems={selectedItems}
              selectedParent={selectedParent} onToggle={onToggle} onSelect={onSelect} withCheckboxes={withCheckboxes} />
            ))}
          </div>
        )}
      </div>
    );
  };
  
  // Компонент Tree для отображения всего дерева
  const Tree = ({ items, selectedId, selectedParent, selectedItems, onToggle, onSelect, withCheckboxes }) => {
    const buildTree = (items, parentId, visited = new Set()) => {
      // Добавляем проверку, чтобы не было зацикливания
      if (visited.has(parentId)) return [];
      visited.add(parentId);
  
      return items
        .filter(item => item.parent === parentId && item.id !== parentId)
        .map(item => ({
          item,
          children: buildTree(items, item.id, visited),
        }));
    };
  
    // Получаем все уникальные id
    const itemIds = new Set(items.map(item => item.id));
  
    // Поиск корневых элементов (где id и parent равны или parent не существует среди id)
    const rootItems = items.filter(item => 
      item.parent === null || !itemIds.has(item.parent) || item.id === item.parent
    );
  
    // Строим дерево для каждого корневого элемента
    const treeData = rootItems.map(rootItem => ({
      item: rootItem,
      children: buildTree(items, rootItem.id),
    }));
  
    return (
      <div>
        {treeData.map(node => (
          <TreeNode key={node.item.id} item={node.item} children={node.children} selectedId={selectedId}
          selectedParent={selectedParent} selectedItems={selectedItems} onToggle={onToggle} onSelect={onSelect} withCheckboxes={withCheckboxes} />
        ))}
      </div>
    );
  };

export default Tree;